const NAME_REGEX = /^[A-Z a-z\u0600-\u06FF]{3,30}$/;
const TEXT_REGEX = /^.{9,50}$/;

export default function ContactUsFormValidation(inputs: any) {
    let errors = {
        name: "",
        email: "",
        text: ""
    };
    let condition = true;

    if (!inputs.name) {
        errors.name = "Name is required";
        condition = false;
    } else if (!NAME_REGEX.test(inputs.name)) {
        errors.name = "Should be more than two alphabets(A-Za-z)";
        condition = false;
    }
    if (!inputs.email) {
        errors.email = "Email address is required";
        condition = false;
    } else if (!/\S+@\S+\.\S+/.test(inputs.email)) {
        errors.email = "Email address is invalid";
        condition = false;
    }
    if (!inputs.text) {
        errors.text = "Please enter your message";
        condition = false;
    } else if (!TEXT_REGEX.test(inputs.text)) {
        errors.text =
            "Message should be between 9 to 140 characters";
        condition = false;
    }
    return { errors, condition };
}
